import React from 'react';
import PropTypes from 'prop-types';
import uid from 'utils/uid';
import { ArrowRight, News } from 'core/icons';
import { Button, Hairline } from 'elements';
import NewsItem from './components/NewsItem';
import pushLocation from 'utils/pushLocation';
import { NewsList, MoreButtonGroup } from './styled';

class NewsSection extends React.PureComponent {
  static contextTypes = {
    router: PropTypes.object,
  };

  render() {
    const { data, teksti } = this.props;

    const mapSectionIcon = (id) => {
      switch (id) {
        case 'news':
          return News;
        default:
      }
    }

    return (
      <section>
        <Hairline
          icon={mapSectionIcon(data.icon)}
          title={data.title}
        />

        <NewsList>
          {
            data.items.map(item => (
              <NewsItem
                key={uid()}
                title={item.title}
                date={item.date}
                location={item.location}
              />
            ))
          }
        </NewsList>

        {
          data.more && (
            <MoreButtonGroup gutter={false}>
              <Button
                label={data.more.label}
                icon={ArrowRight}
                onClick={() => pushLocation(data.more.location, this.context.router)}
                type='outlined'
              />
            </MoreButtonGroup>
          )
        }
      </section>
    );
  }
}

export default NewsSection;



// WEBPACK FOOTER //
// ./src/modules/NewsSection/NewsSection.jsx